var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4732 0.360076C8.21536 0.101898 7.79668 0.102061 7.5385 0.360076L5.20141 2.69726C4.16881 3.7299 2.49461 3.72991 1.46199 2.6973C1.20381 2.43912 0.785308 2.43912 0.52713 2.6973C0.268952 2.95548 0.268952 3.37398 0.52713 3.63216L2.86419 5.96922C2.9932 6.09823 3.16236 6.1629 3.33154 6.1629C3.50072 6.1629 3.67004 6.09839 3.79905 5.96922L8.4732 1.29492C8.73137 1.03692 8.73137 0.618238 8.4732 0.360076Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInput);
export default __webpack_public_path__ + "static/media/check-input.3b6e76bc19a6cbe232aff9abedcc4d5a.svg";
export { ForwardRef as ReactComponent };